/* eslint-disable @typescript-eslint/naming-convention */

export enum MessageRequestType {
  publish = 'publish',
  subscribe = 'subscribe',
  request = 'request',
  response = 'response',
  broadCast = 'broadCast',
}

export const APPLICATION_EVENTS = {
  AUTH: {
    INITIALIZE: {
      topic: 'initialize',
      messageType: 'publish',
    },
    AUTH_STATUS: {
      topic: 'auth_status',
      messageType: 'request', // need to move these types
    },
    AUTH_STATUS_CHANGE: {
      topic: 'auth_status_change',
      messageType: 'request', // need to move these types
    },
    LOAD_AUTH_SCREEN: {
      topic: 'auth_screen',
      messageType: 'publish', // need to move these types
    },
  },
  WORKSPACE: {
    GET_ACTIVE_WORKSPACE: {
      topic: 'get_active_workspace',
      messageType: 'request',
    },
    SAVE_WORKSPACE: {
      topic: 'save_workspace',
      messageType: 'request',
    },
  },
  SETTINGS: 'settings',
  PREFERENCES: 'preferences',
  WORKSPACES: 'workspaces',
  APPLICATIONS: 'applications',
};

export type MessageRequest = {
  messageType: MessageRequestType;
  topic: string;
  message: any;
  meta?: any;
  sender?: string;
};

export type LinkerGroup = {
  icon: string;
  tabIcon?: string;
  name: string;
};

export type LinkerGroups = Record<string, LinkerGroup>;

export enum DefaultLinkerGroupKeys {
  GROUP_1 = 'group1',
  GROUP_2 = 'group2',
  GROUP_3 = 'group3',
}
